import { ContentCard } from "@msuite/ui/content-card";
import { icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { ConnectOrganizationForm } from "@/forms/connect-organization-form";

export function OrganizationSettingsInvitationCodes() {
	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<ContentCard
			title={t("organization.invitation_codes")}
			icon={icon("ChevronsLeftRightEllipsis")}
		>
			<ConnectOrganizationForm />
		</ContentCard>
	);
}
